var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightUmbrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V3H14C17.866 3 21 6.13401 21 10V13.1315C21 13.9302 20.1099 14.4066 19.4453 13.9635L18.5547 13.3698C18.2188 13.1459 17.7812 13.1459 17.4453 13.3698L15.5547 14.6302C15.2188 14.8541 14.7812 14.8541 14.4453 14.6302L12.75 13.5V21.25H16C16.4142 21.25 16.75 21.5858 16.75 22C16.75 22.4142 16.4142 22.75 16 22.75H8C7.58579 22.75 7.25 22.4142 7.25 22C7.25 21.5858 7.58579 21.25 8 21.25H11.25V13.5L9.5547 14.6302C9.2188 14.8541 8.7812 14.8541 8.4453 14.6302L6.5547 13.3698C6.2188 13.1459 5.7812 13.1459 5.4453 13.3698L4.5547 13.9635C3.89014 14.4066 3 13.9302 3 13.1315V10C3 6.13401 6.13401 3 10 3H11.25V2C11.25 1.58579 11.5858 1.25 12 1.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightUmbrella);
export default __webpack_public_path__ + "static/media/light-umbrella.e8a988df3ce17663b6388afa5447a504.svg";
export { ForwardRef as ReactComponent };